import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Store } from '@ngrx/store';
import { takeUntil, switchMap, filter, pluck } from 'rxjs/operators';
import { ReplaySubject, combineLatest, merge, of } from 'rxjs';
import { Actions, Selectors } from 'store/root-reducer';
import { CustomerService } from 'modules/core/services/customer.service';
var CustomerParticularsComponent = /** @class */ (function () {
    function CustomerParticularsComponent(activatedRoute, store, router, customerService, cdRef) {
        this.activatedRoute = activatedRoute;
        this.store = store;
        this.router = router;
        this.customerService = customerService;
        this.cdRef = cdRef;
        this.unsubscribe$ = new ReplaySubject(1);
    }
    CustomerParticularsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute
            .params
            .pipe(takeUntil(this.unsubscribe$)).subscribe(function (params) {
            _this.store.dispatch(new Actions.customer.GetCustomer({ customerId: params['id'] }));
        });
        var crpId = null;
        if (this.activatedRoute.firstChild) {
            crpId = this.activatedRoute.firstChild.snapshot.params['crpId'];
        }
        this.initCustomerParticulars(crpId);
        this.checkCrpChanges();
        this.customerService.getAppConfig()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (item) {
            _this.dataAvailableFormFields = item;
        });
    };
    CustomerParticularsComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
        this.store.dispatch(new Actions.record.ResetRecord());
        this.store.dispatch(new Actions.customer.ResetCustomerOverview());
    };
    CustomerParticularsComponent.prototype.checkCrpChanges = function () {
        var _this = this;
        this.router.events.pipe(takeUntil(this.unsubscribe$), filter(function (event) { return event instanceof NavigationEnd; }), switchMap(function () {
            return (_this.activatedRoute.firstChild && _this.activatedRoute.firstChild.params)
                || of({});
        }), pluck('crpId')).subscribe(function (crpId) {
            if (crpId) {
                _this.initCustomerParticulars(crpId);
            }
            else {
                _this.initCustomerParticulars();
            }
        });
    };
    CustomerParticularsComponent.prototype.initCustomerParticulars = function (crpId) {
        var _this = this;
        combineLatest([
            merge(this.store.select(Selectors.record.getIndividualRecord), this.store.select(Selectors.record.getCorporateRecord)),
            this.store.select(Selectors.customer.getCustomer),
            this.store.select(Selectors.customer.getCrps)
        ])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (_a) {
            var record = _a[0], customer = _a[1], crps = _a[2];
            if (record && customer) {
                _this.record = record;
                _this.customer = customer;
                var handshakeReport = _this.record['handshakesReports'];
                var handShakesReportExist = handshakeReport !== undefined;
                if (handShakesReportExist && handshakeReport.length > 0) {
                    var latestHandshakeReport = handshakeReport.length - 1;
                    if (_this.record.addresses.length === 0 && handshakeReport[latestHandshakeReport].hasOwnProperty('currentAddress')) {
                        var handshakeAddress = _this.record['handshakesReports'][latestHandshakeReport]['currentAddress'];
                        _this.record.addresses = [handshakeAddress];
                    }
                }
            }
            if (crps.results && crps.results.length > 0) {
                if (crpId) {
                    _this.crp = crps.results.find(function (crp) { return crp.id.toString() === crpId; });
                }
                else {
                    _this.crp = crps.results.find(function (crp) { return crp.primary === true; });
                }
            }
            // Change detection on destroyed view
            if (customer) {
                _this.cdRef.detectChanges();
            }
        });
    };
    return CustomerParticularsComponent;
}());
export { CustomerParticularsComponent };
